<template>
  <img :src="speech_details" alt="" width="100%" />
</template>

<script>
import speech_details from "@/assets/images/speech_details.svg";
export default {
  name: "SpeechSkeleton",
  data() {
    return {
      speech_details,
    };
  },
};
</script>

<style scoped></style>
